import { IMarker, useTranslation } from "./app";

export function Card({ item }: { item: IMarker }) {
  const t = useTranslation();
  return (
    <div className="group/preview rounded-lg p-4 grid w-full overflow-hidden justify-between gap-4 bg-secondary-background">
      <div className="flex flex-col gap-4 flex-grow">
        <div className="flex flex-col gap-2 flex-grow">
          {item.tag && <p className="tag">{item.tag}</p>}
          <h3 className="text-lg font-bold line-clamp-2 font-quicksand">
            {item.title}
          </h3>
        </div>
        <div className="flex flex-col gap-1 font-semibold font-quicksand">
          <span
            dangerouslySetInnerHTML={{
              __html: item.date ? item.date : t("point_open_on_appointment"),
            }}
          ></span>
          {item.location.address} {item.location.number}, {item.location.city}
          {item.email && (
            <span>
              {t("link_email")}: {item.email}
            </span>
          )}
          {item.phone && (
            <span>
              {t("link_phone")}: {item.phone}
            </span>
          )}
        </div>
        <div className="flex gap-1 items-center text-primary relative w-fit">
          <span className="font-bold font-quicksand ">
            <span className="sr-only">
              {t("about")} {item.title}
            </span>
          </span>
          <span className="custom-underline group-hover/preview:opacity-100"></span>
        </div>
      </div>
    </div>
  );
}
